import { render } from "./Popup.vue?vue&type=template&id=128385b6"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=128385b6&lang=scss"

import exportComponent from "D:\\work\\beam\\Project\\DAPPS\\beam-dapps\\nft_gallery_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__